import { render, staticRenderFns } from "./NumerationConfig.vue?vue&type=template&id=23066dd5&scoped=true&"
import script from "./NumerationConfig.vue?vue&type=script&lang=js&"
export * from "./NumerationConfig.vue?vue&type=script&lang=js&"
import style0 from "./NumerationConfig.vue?vue&type=style&index=0&id=23066dd5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23066dd5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23066dd5')) {
      api.createRecord('23066dd5', component.options)
    } else {
      api.reload('23066dd5', component.options)
    }
    module.hot.accept("./NumerationConfig.vue?vue&type=template&id=23066dd5&scoped=true&", function () {
      api.rerender('23066dd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/NumerationConfig.vue"
export default component.exports